import AuditLogin from '@/models/AuditLogin/AuditLogin';

export default class AuditLoginFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.loginTimeFrom = '';
		this.loginTimeTo = '';
		this.userId  = '';
		this.userFirstName = '';
		this.ipAddress = '';
		this.isLoginSuccess = false;
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			loginTimeFrom : '0',
			loginTimeTo : '0',
			userId : '0',
			userFirstName : '0',
			ipAddress : '0',
			isLoginSuccess : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}